import { FC } from 'react';
import styled from 'styled-components';
import i18next from 'i18next';

import SecondaryButtonLoading from '~src/shared/buttons/loadingButtons/SecondaryButtonLoading';

const NoDeletionMessage = styled.div`
  display: flex;
  align-items: center;
  padding: 0.4rem;
  color: ${({ theme }) => theme.baseBlue.a6};
`;
const FrameworkBox = styled.div`
  font-size: 0.733rem;
  font-weight: 600;
  line-height: 1.6rem;
  letter-spacing: 0.2px;
  text-align: center;
  padding: 3px 10px;
  margin-right: 5px;
  border-radius: 5px;
  color: ${({ theme }) => theme.lightBlue.a10};
  background-color: rgba(203, 227, 255, 0.5);
`;

interface DefaultProps {
  isFramework: boolean;
  isLoading: boolean;
  frameworkKey: string;
  noDelKey: string;
  btnKey: string;
}

interface Props extends Partial<DefaultProps> {
  t: i18next.TFunction;
  delAction(): void;
}

const FrameworkDelAction: FC<Props> = ({
  t,
  delAction,
  isFramework = false,
  isLoading = false,
  frameworkKey = 'x.topics.details.box.framework',
  noDelKey = 'x.topic.details.header.menu.no_delete_topic',
  btnKey = 'x.shared.form.delete_button',
}) =>
  isFramework ? (
    <NoDeletionMessage>
      <FrameworkBox data-translation={frameworkKey}>{t(frameworkKey)}</FrameworkBox>
      <span data-translation={noDelKey}>{t(noDelKey)}</span>
    </NoDeletionMessage>
  ) : (
    <SecondaryButtonLoading $buttonColor="reddish" onClick={delAction} isLoading={isLoading}>
      <span data-translation={btnKey}>{t(btnKey)}</span>
    </SecondaryButtonLoading>
  );

export default FrameworkDelAction;
